<template>
<div class="h-screen">
<div class="flex content-center items-center h-full">

      <img v-if="dark" class="transition-all delay-300 duration-150 ease-in-out object-contain xl:w-1/3 w-1/2 mx-auto" src="../assets/images/FREED FROM DESIGNER.png" alt="">
      <img v-else class="transition-all delay-300 duration-150 ease-in-out object-contain w-1/2 xl:w-1/3 mx-auto" src="../assets/images/FREED FROM DESIGNER LIGHT.png" alt="">

</div>

</div>

</template>
<script>

export default {
  name: 'Home',
  props: {
    dark: {
      type: Boolean
    }
  },
}
</script>
<style scoped>
  
</style>